import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const SaveIcon = ({
  width=24,
  height=24,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg
      width={width} 
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.003 4.4985C15.003 3.6709 15.6739 3 16.5015 3V3C17.3291 3 18 3.6709 18 4.4985V6.5015C18 7.3291 17.3291 8 16.5015 8V8C15.6739 8 15.003 7.3291 15.003 6.5015V4.4985ZM23.5607 3.56066C23.842 3.84197 24 4.2235 24 4.62132V22.5C24 23.3284 23.3284 24 22.5 24H1.5C0.671573 24 0 23.3284 0 22.5V1.5C0 0.671573 0.671573 0 1.5 0H19.3787C19.7765 0 20.158 0.158035 20.4393 0.43934L23.5607 3.56066ZM5 7.5C5 8.32843 5.67157 9 6.5 9H17.5C18.3284 9 19 8.32843 19 7.5V3.5C19 2.67157 18.3284 2 17.5 2H6.5C5.67157 2 5 2.67157 5 3.5V7.5ZM21 14.5C21 13.6716 20.3284 13 19.5 13H4.5C3.67157 13 3 13.6716 3 14.5V20.5C3 21.3284 3.67157 22 4.5 22H19.5C20.3284 22 21 21.3284 21 20.5V14.5Z"
        fill={strokeColor}
      />
    </svg>
  )
}

export default SaveIcon
